import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import MethodHero from './components/MethodHero';
import MethodDetails from './components/MethodDetails';
import ClientSuitability from './components/ClientSuitability';
import StabilityPathway from './components/StabilityPathway';
import { setPageMeta, injectJsonLd, removeJsonLd } from '../../utils/seo';

const MethodPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    const siteUrl = import.meta.env.VITE_SITE_URL || '';
    
    // Set page meta tags
    setPageMeta(
      'Vionne Stability Method | Premium Facial Structure Regulation',
      'Discover the Vionne Stability Method: a comprehensive approach to facial structure regulation through nervous system optimization, acupuncture, and holistic wellness for sustainable results.',
      `${siteUrl}/method`
    );

    // Inject JSON-LD schema
    const schema = [
      {
        '@context': 'https://schema.org',
        '@type': 'Service',
        '@id': `${siteUrl}/method#service`,
        name: 'Vionne Stability Method',
        serviceType: 'Facial Structure Regulation & Nervous System Optimization',
        provider: {
          '@type': 'LocalBusiness',
          name: 'Vionne Stability',
          url: siteUrl,
          '@id': `${siteUrl}/#business`
        },
        areaServed: {
          '@type': 'City',
          name: 'Vancouver',
          '@id': 'https://en.wikipedia.org/wiki/Vancouver'
        },
        description: 'The Vionne Stability Method combines advanced acupuncture techniques with nervous system regulation to optimize facial structure and promote holistic wellness. A comprehensive approach addressing the root causes of facial tension and structural imbalance.',
        url: `${siteUrl}/method`,
        offers: {
          '@type': 'Offer',
          availability: 'https://schema.org/InStock',
          priceRange: '$$$$',
          url: `${siteUrl}/booking`
        },
        hasOfferCatalog: {
          '@type': 'OfferCatalog',
          name: 'Stability Method Services',
          itemListElement: [
            {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'Service',
                name: 'Nervous System Regulation',
                description: 'Comprehensive nervous system optimization for sustainable facial structure improvement'
              }
            },
            {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'Service',
                name: 'Facial Structure Acupuncture',
                description: 'Advanced acupuncture techniques for facial rejuvenation and structural balance'
              }
            },
            {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'Service',
                name: 'Holistic Wellness Integration',
                description: 'Integrated approach combining internal regulation with external transformation'
              }
            }
          ]
        },
        additionalType: 'https://schema.org/MedicalTherapy',
        category: 'Acupuncture & Facial Wellness'
      }
    ];

    injectJsonLd(schema);

    return () => {
      removeJsonLd();
    };
  }, []);

  return (
    <div className="min-h-screen bg-warmWhite">
      <Navbar />
      <main>
        <MethodHero />
        <MethodDetails />
        <ClientSuitability />
        <StabilityPathway />
      </main>
      <Footer />
    </div>
  );
};

export default MethodPage;